import { queryClient } from './query-client';

/**
 * Função pura para limpar dados de autenticação
 * Esta função pode ser reutilizada tanto pelo useLogout quanto pelo interceptor HTTP
 */
export function clearAuthData(): void {
  try {
    // Limpar cookie de autenticação
    document.cookie = 'x-auth-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // Limpar dados do usuário do localStorage
    localStorage.removeItem('user');

    // Limpar cache do React Query
    queryClient.clear();
  } catch (error) {
    console.error('Erro ao limpar dados de autenticação:', error);
  }
}

/**
 * Função global para fazer logout quando detectado erro 401
 * Esta função pode ser chamada de qualquer lugar, incluindo interceptors HTTP
 */
export function logoutUser(): void {
  clearAuthData();
  console.log('Logout automático realizado devido a erro 401');
}
